<template>
  <section class="content_section">
    <SimpleList ref="simpleList" v-if="isLoaded" :serverside="false" @filter="getFiltered"
                :tripsSource="'getAllTrips'"
                :data="trips" :options="options" :title=options.Lang.Auswertung :defaultCount="defaultCount" :cols="cols" :hideCols="hideCols"
                :emptyState=options.Lang.Keine_Auswertung_vorhanden buttonAction="ImportTrip" :brands="brands" :usersAuswertung="users"
                :clean="false" @updateData="getAll"
                :initialDate1="filterDate1" :initialDate2="filterDate2" :initialBrand="filterBrand"
                :isAuswertung="true"></SimpleList>

  </section>
</template>
<script>

import SimpleList from "@/components/lists/SimpleList";
import FormUser from "@/components/dialogs/FormUser";
import FormClient from "@/components/dialogs/FormClient";
import FormSendEmailToSupplier from "@/components/dialogs/FormSendTripToSupplier";
import FormImportTrip from "@/components/dialogs/FormImportTrip";
import FormUploadPdf from "@/components/dialogs/FormUploadPdf";
import FormTimeline from "@/components/dialogs/FormTimeline";
import FormEditHello from "@/components/dialogs/FormEditHello";
import FormFirstImage from "@/components/dialogs/FormFirstImage";
import FormCustomerLogin from "@/components/dialogs/FormCustomerLogin";
import * as moment from 'moment'
import FormAddKommentar from "../../components/dialogs/FormAddKommentar.vue";

const toLower = text => {
  if (text !== null) {
    return text.toString().toLowerCase()
  } else {
    return "";
  }
}

export default {
  name: 'trips',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  components: {
    SimpleList,
    FormClient,
    FormUser,
    FormImportTrip,
    FormSendEmailToSupplier,
    FormUploadPdf,
    FormEditHello,
    FormTimeline,
    FormFirstImage,
    FormCustomerLogin,
    FormAddKommentar
},
  data() {
    return {
      
      userSeeStatus: null,
      showAlert: false,
      alert: [],
      imgs: [],
      defaultCount: null,
      search: null,
      searchedTrips: [],
      selectedTrips: [],
      trips: [],
      users: [],
      tripsAuswertung: [],
      usersAuswertung: [],
      brands: [],
      filterDate1: moment().subtract(1, 'days').format('YYYY-MM-DD'),
      filterDate2: moment().format('YYYY-MM-DD'),
      filterBrand: 'alle',
      hideCols: ['id', 'role', 'username', 'pic', 'telefon', 'seeAlert', 'brandings', 'supersuper', 'password', 'role', 'company', 'status', 'deleted', 'updatedBy', 'updatedAt', 'createdAt', 'lang', 'activation_code', 'activation_expires', 'trips_isolated', 'email', 'totp_enabled'],
      cols: ['firstname', 'lastname', 'count', 'countMailSent', 'countUser', 'brandingName'],
      isLoaded: false,
      actions: [
        
      ],
    };
  },
  beforeCreate() {
  },
  beforeMount() {
  },
  async created() {
    this.options.isUploading = true;
    await this.getCurrentUser();
    this.isLoaded = true;
    this.options.isUploading = false;

  },
  async mounted(){
    await this.getAllBrandings();
    await this.getCurrentUser();
    this.isLoaded = true;
    this.options.isUploading = false;

    let self = this;

    self.defaultCount = self.options.defaultCount;

    if(self.options.currentRoute != 'Brandings'){
      self.options.showBrandForm = false;
    }

    this.$nextTick(() => {
      if (this.$refs.simpleList && this.filterDate1 && this.filterDate2 && this.filterBrand) {
        this.$refs.simpleList.applyAuswertungFilter();
      }
    });
  },

  methods: {
    async getAllBrandings() {
      this.brands = [];
      let self = this;
      await self.doPost({}, 'getAllBranding', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data;  
          for(let i = 0; i < result.length; i++){
            self.brands.push(result[i])
          }
        }
      });    
     // console.log(self.brands, "brands----")
    },

    async getAll(args) {
      let count = this.options.defaultCount
      let self = this;

      //console.log(args, "args")

      let brand = args?.brand ? args.brand : ''
      let date1 = args?.date1 ? args.date1 : ''
      let date2 = args?.date2 ? args.date2 : ''

      // Save filter values to persist them (use raw dates for datepicker compatibility)
      if (args?.brand) this.filterBrand = args.brand;
      if (args?.rawDate1) this.filterDate1 = args.rawDate1;
      if (args?.rawDate2) this.filterDate2 = args.rawDate2;

      // Ensure brands are loaded first
      if (!self.brands || self.brands.length === 0) {
        await self.getAllBrandings();
      }

      await self.getAllUser();
      await self.getTripsAuswertung(brand, date1, date2);
      await self.getAuswertungArray();

      self.isLoaded = true;
      self.options.isUploading = false;

    },
    getAllUser() {
      let self = this;
      return this.doPost({userdata: self.options.user}, 'getAllUsers', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data
          self.usersAuswertung = result
        }
        self.isLoaded = true;
      });
    },
    async getAuswertungArray(){
      if(this.tripsAuswertung.length > 0 && this.usersAuswertung.length > 0){
        console.log('Brands array:', this.brands);
        console.log('Trips data:', this.tripsAuswertung);

        this.usersAuswertung.forEach(user =>{
          user.count = 0
          user.countMailSent = 0
          user.countUser = 0

          // Collect unique branding IDs from the user's trips
          let tripBrandingIds = new Set();

          this.tripsAuswertung.forEach(trip =>{
            if(user.firstname == trip.firstname && user.lastname == trip.lastname){
              user.count++
              if(trip.countUser != null){
                user.countUser++
              }
              if(trip.timestampCustomerMail != null && trip.timestampCustomerMail !== ''){
                user.countMailSent++
              }
              // Collect the branding_id from this trip
              if(trip.branding_id) {
                tripBrandingIds.add(trip.branding_id);
              }
            }
          })

          // Convert branding IDs to branding names
          let brandingNames = [];
          if (this.brands && this.brands.length > 0) {
            tripBrandingIds.forEach(brandingId => {
              let brand = this.brands.find(b => b.id == brandingId);
              if (brand) {
                brandingNames.push(brand.adresse);
              }
            });
          }

          user.brandingName = brandingNames.length > 0 ? brandingNames.join(', ') : '-';
          console.log('User:', user.firstname, user.lastname, 'Brandings:', user.brandingName);
        })
        this.trips = this.usersAuswertung
      }else{
        this.isLoaded = false;
        this.options.isUploading = true;
        this.trips = []
      }
    },
    async getTripsAuswertung(brand, date1, date2){
      let myData = {
        brand : brand,
        date1: date1,
        date2: date2
      }
      let self = this;
      await this.doPost({
              userdata: self.options.user, data: myData
              }, 'getAllTripsAuswertung', function (res) {
              if (res.data.status === 'error') {
                self.help.log(self.$t(res.msg), false, true);
              } else {
                let result = res.data.data
                self.tripsAuswertung = result;
              }
              self.options.isUploading = false;
              window.setTimeout(function(){self.isLoaded = true;}, 500)
            });
    },
    getFiltered(args) {
      let self = this;
      self.options.isUploading = true;
      let where = args && args.where ? args.where : null;
      let order = args && args.order ? args.order : null;
      this.doPost({
        userdata: self.options.user,
        data: {
          where: where,
          sort: order
        },
        brandings: self.$store.getters.getUser.brandings
      }, 'getAllTrips', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.responseToTableData(res.data.data, self.cols).then(values => {
            self.trips = values;
            const count = self.trips.length;
            for(let i=0; i<count;i++){
              self.trips[i].trip_date= moment(self.trips[i].date_start).format('DD MMM YYYY') + ' - ' + moment(self.trips[i].date_end).format('DD MMM YYYY')
            }
          })
        }
        self.options.isUploading = false;
        self.isLoaded = true;
      });
    },

    async getCurrentUser() {
      let self = this;
      await this.doPost({userdata: self.options.user, data: self.options.user.id}, 'getUserById', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data; 
          self.setNewUserOptions(result);
        }})
    },

    setNewUserOptions(result){
      this.options.user.brandings = result.brandings;
    }
  }
};
</script>
<style>
  #alertBox{
    position: absolute;
    min-height: 5rem;
    max-height: 25rem;
    overflow-y: scroll;
    width: 60%;
    top: 15rem;
    left: 15%;
    background-color: white !important;
    z-index: +111111111;
  }
</style>